<div class="modal-header">
    <h4 class="modal-title">Reopen Day</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
  
    <div class="inner-modal-body">
      <p>Are you sure you want to reopen the day?</p>
      <div class="__actions gs keep-lay">
        <div class="lay-50 lay-left">
          <button class="btn btn-primary btn-sm btn-block" (click)="completeDaily()" [ngClass]="{'btn-loading': loading}"><span>Yes</span></button>
        </div>
        <div class="lay-50 lay-right">
          <button class="btn btn-secondary btn-secondary-outline btn-sm btn-block" (click)="activeModal.dismiss('Cross click')">No</button>
        </div>
      </div>
    </div>
  </div>